import { RouteObject, useRoutes } from 'react-router-dom';

import { UserTypes } from '@constants/role';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import { getLocalStorageItem } from '@utils/storage';

import { adminRoutes, mainRoutes } from './routes';

const AppRoutes = () => {
  const routesConfig: RouteObject[] =
    getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_TYPE) === UserTypes.ADMIN
      ? adminRoutes
      : mainRoutes;

  const Routes = useRoutes([...routesConfig]);

  return Routes;
};

export default AppRoutes;
